<template>

    <v-dialog v-model="showDialog" persistent max-width="800px">

        <v-sheet rounded class="dialog">

            <v-card
                elevation="0"
                class="pa-5 font-weight-bold rounded-b-0"
                color="headerDialogColor"
            >
                {{ $t("direct_outputs.outputs_history") }}
            </v-card>

            <v-card elevation="0" class="pa-5">

                <footer-datatable-adapter v-slot="{footerProps}">
                    <v-data-table
                        :headers="logisticalLotHistoriesHeaders"
                        :items="logisticalLotHistories"
                        :options.sync="options"
                        :server-items-length="totalElements"
                        :footer-props="footerProps"
                        @update:options="getLogisticalLotHistories"
                    >
                        <template #[`item.pdf`]="{ item }">
                            <v-icon
                                v-if="item.type === 'EDIT_DIRECT_OUTGOINGS_REPORT'"
                                size="16"
                                class="pdf rounded pa-1"
                                color="white"
                                @click="$emit('getDeliveryReport', item.payload.edited_at)"
                            >
                                mdi-file-pdf
                            </v-icon>
                            <span v-else>-</span>
                        </template>

                        <template #[`item.sticker`]="{ item }">

                            <v-icon
                                v-if="item.payload.delivery_service === 1 && (item.type === 'CREATION' || item.type === 'UPDATE')"
                                size="16"
                                class="print rounded pa-1"
                                color="white"
                                :title="$t('direct_outputs.sticker_print_action')"
                                @click="$emit('printSticker', item.historisable_id)"
                            >
                                mdi-printer
                            </v-icon>

                            <span v-else>-</span>

                        </template>

                        <template #[`item.qrcode`]="{ item }">

                            <v-icon
                                v-if="item.type === 'CREATION'"
                                v-can="$roles.ADMIN"
                                size="16"
                                class="qrcode rounded pa-1"
                                color="white"
                                :title="$t('direct_outputs.qr_code_action')"
                                @click="getQrCode(item.payload.code)"
                            >
                                mdi-qrcode-scan
                            </v-icon>

                            <span v-else>-</span>

                        </template>
                        
                    </v-data-table>
                </footer-datatable-adapter>

            </v-card>

            <v-divider></v-divider>

            <v-card elevation="0" class="pa-5 d-flex align-items-center">

                <v-btn
                    elevation="0"
                    text
                    @click="showDialog = false"
                >
                    {{ $t("global.cancel") }}
                </v-btn>

                <v-spacer></v-spacer>
            </v-card>

        </v-sheet>

        <lot-qr-code-modal
            v-if="qrCode"
            :qr-code="qrCode"
            :visible="showQrCodeDialog"
            @close="qrCode = null"
        />

    </v-dialog>

</template>

<script>

import FooterDatatableAdapter from "../../components/FooterDatatableAdapter";
import Roles from "../../ressources/roles";
import LotQrCodeModal from "../../components/Lots/LotQrCodeModal.vue";

export default {
    name: "AllHistory",
    components: {
        LotQrCodeModal,
        FooterDatatableAdapter
    },
    props: {
        visible: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            logisticalLotHistoriesHeaders: [
                {
                    text: this.$t("global.date") + " / " + this.$t("global.time"),
                    value: "created_at",
                },
                {
                    text: this.$t("global.actions"),
                    value: "type",
                },
                {
                    text: this.$t("global.author"),
                    value: "by",
                },
                {
                    text: this.$t("direct_outputs.nb_boxes"),
                    value: "payload.container_quantity",
                    align: "center",
                },
                {
                    text: this.$t("global.pdf"),
                    value: "pdf",
                    sortable: false,
                    align: "center",
                },
                {
                    text: this.$t("direct_outputs.tag"),
                    value: "sticker",
                    sortable: false,
                    align: "center",
                },
            ],
            logisticalLotHistories: [],
            totalElements: 0,
            options: {
                itemsPerPage: 10
            },
            qrCode: null,
            showQrCodeDialog: false,
        };
    },
    computed: {
        showDialog: {
            get() {
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },
    mounted() {
        if (this.$auth.check(Roles.ADMIN)) {
            this.logisticalLotHistoriesHeaders.push(
                {
                    text: this.$t("direct_outputs.qr_code"),
                    align: "center",
                    value: "qrcode",
                }
            );
        }
    },
    methods: {
        async getLogisticalLotHistories() {
            let data = await this.$api.history.all({
                params: {
                    ...this.options,
                    history_direct_outgoings_from_buyer_id: this.$route.params.companyId
                },
            });

            this.logisticalLotHistories = data.data.data
            this.options.page = data.data.meta.current_page;
            this.totalElements = data.data.meta.total;
        },
        async getQrCode(code) {
            let qrCode = await this.$api.logisticalLot.getQrCode(code);
            this.qrCode = qrCode.data;
            this.showQrCodeDialog = true;
        }
    }
};
</script>
